import { ENV } from '@/configurations/env';
import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER, } from 'redux-persist';
import { middlewares } from './middlewares/rootMiddleware';
import { rootSaga } from './middlewares/rootSaga';
import { createReduxHistory } from './middlewares/routerMiddleware';
import { sagaMiddleware } from './middlewares/sagaMiddleware';
import { persistReducers } from './reducers/persistReducer';
import { reducers } from './reducers/rootReducer';
var persistedReducer = persistReducers(reducers);
export var store = configureStore({
    devTools: ENV.SHOW_REDUX_LOGGER,
    reducer: persistedReducer,
    middleware: function (getDefaultMiddleware) {
        return getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }).concat(middlewares);
    },
});
sagaMiddleware.run(rootSaga);
export var persistor = persistStore(store);
export var history = createReduxHistory(store);
export var useReduxDispatch = useDispatch;
export var useReduxSelector = useSelector;
